module.exports = __webpack_public_path__ + "img/3.c5ab4a87.png";